<ng-template #languageContent>
  <div class="language-body">
    <div class="language-section-title">
      {{ 'languageSwitcher.selectLanguage' | transloco }}
    </div>
    <ion-radio-group
                     [value]="selectedLanguage"
                     (ionChange)="onLanguageChange($event)">
      <div
           *ngFor="let lang of languageOptions$ | async"
           class="language-option"
           [class.selected]="selectedLanguage === lang.code"
           (click)="selectLanguage(lang.code)">
        <div class="language-option-header">
          <ion-radio [value]="lang.code" mode="md"></ion-radio>
          <div class="language-info">
            <div class="language-name">{{ lang.name }}</div>
            <div class="language-native">{{ lang.nativeName }}</div>
          </div>
          <div class="primary-badge" *ngIf="lang.isPrimary">
            <ion-icon name="checkmark-outline" color="success"></ion-icon>
            <span>{{ 'languageSwitcher.primary' | transloco }}</span>
          </div>
        </div>
        <div
             class="language-option-body"
             *ngIf="selectedLanguage === lang.code && !lang.isPrimary && lang.translationNoticeKey">
          <div class="info-message translation-info">
            <ion-icon name="information-circle" color="primary"></ion-icon>
            <div class="info-content">
              <span>{{ lang.translationNoticeKey | transloco }}</span>
            </div>
          </div>
        </div>
      </div>
    </ion-radio-group>
  </div>
  <div class="language-footer">
    <ion-button
                expand="block"
                [color]="hasPendingLanguageChange ? 'primary' : 'medium'"
                [disabled]="!hasPendingLanguageChange"
                class="apply-button"
                (click)="applyLanguageSelection()">
      {{ 'languageSwitcher.applySelection' | transloco }}
    </ion-button>
  </div>
</ng-template>

<div *ngIf="showSwitcher$ | async" class="language-selector-wrapper">
  <!-- Button trigger for both modes -->
  <ion-button
              fill="clear"
              [id]="mode === 'popover' ? triggerId : null"
              class="language-button"
              [color]="color"
              (click)="mode === 'modal' ? openModal() : null">
    <ion-icon slot="start" name="globe-outline"></ion-icon>
    <span class="ion-text-uppercase">{{ currentLanguageCode$ | async }}</span>
    <ion-icon slot="end" name="chevron-up-outline"></ion-icon>
  </ion-button>

  <!-- Popover Mode -->
  <ion-popover
               *ngIf="mode === 'popover'"
               [trigger]="triggerId"
               [dismissOnSelect]="false"
               class="language-popover"
               [showBackdrop]="true">
    <ng-template>
      <div class="language-popover-content">
        <div class="language-header">
          {{ 'languageSwitcher.title' | transloco }}
        </div>
        <ng-container *ngTemplateOutlet="languageContent"></ng-container>
      </div>
    </ng-template>
  </ion-popover>

  <!-- Modal Mode -->
  <ion-modal
             *ngIf="mode === 'modal'"
             [isOpen]="isModalOpen"
             (didDismiss)="closeModal()"
             class="dynamic-height-modal"
             trigger="open-modal"
             #modal>
    <ng-template>
      <div class="language-modal">
        <div class="language-modal-wrapper">
          <div class="language-modal-header">
            <div
                 class="ion-padding flex ion-justify-content-between ion-align-items-center">
              <ion-text color="white" class="font-bold fs-18px w-100">
                {{ 'languageSwitcher.title' | transloco }}
              </ion-text>
            </div>
          </div>
          <div class="language-modal-content">
            <div class="language-popover-content modal-mode">
              <ng-container *ngTemplateOutlet="languageContent"></ng-container>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </ion-modal>
</div>